import MjpegPlayerNoIframe from './MjpegPlayerNoIframe';
export default MjpegPlayerNoIframe;
